import { render, staticRenderFns } from "./child-errors.vue?vue&type=template&id=1d3e1294&scoped=true&"
import script from "./child-errors.vue?vue&type=script&lang=js&"
export * from "./child-errors.vue?vue&type=script&lang=js&"
import style0 from "./child-errors.vue?vue&type=style&index=0&id=1d3e1294&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e1294",
  null
  
)

export default component.exports